module.exports = __webpack_public_path__ + "static/media/header_mobile.43a24624.png";